import axios from '@/api/axios'
import {pathOr} from 'ramda'

const getDocumentsByParams = (params) => {
  return axios.get(`/documents`, {params}).then((response) => {
    const total = pathOr(null, ['headers', 'x-total-count'], response)
    if (total) {
      return {
        total,
        list: response.data,
      }
    }

    return response.data
  })
}

const getDocument = (id) => {
  return axios.get(`/documents/${id}`)
}

const createDocuments = (document) => {
  return axios.post('/documents', document)
}

const updateDocument = (id, document) => {
  return axios.put(`/documents/${id}`, document)
}

const deleteDocument = (id) => {
  return axios.delete(`/documents/${id}`)
}

const getAthleteDocuments = (athleteId, params) => {
  return axios
    .get(`/athlete/${athleteId}/documents`, {params})
    .then((response) => {
      return response.data
    })
}

const getAthleteDocument = (athleteId, id) => {
  return axios.get(`/athlete/${athleteId}/documents/${id}`)
}

const createAthleteDocuments = (athleteId, document) => {
  return axios.post(`/athlete/${athleteId}/documents`, document)
}

const updateAthleteDocument = (athleteId, id, document) => {
  return axios.put(`/athlete/${athleteId}/documents/${id}`, document)
}

const deleteAthleteDocument = (athleteId, id) => {
  return axios.delete(`/athlete/${athleteId}/documents/${id}`)
}

export default {
  createDocuments,
  getDocument,
  getDocumentsByParams,
  updateDocument,
  deleteDocument,
  getAthleteDocuments,
  createAthleteDocuments,
  deleteAthleteDocument,
  updateAthleteDocument,
  getAthleteDocument,
}
